import {
  ExpandLessIcon,
  ExpandMoreIcon,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuItemProps,
} from '@cmg/design-system';
import React, { FC, PropsWithChildren, ReactNode } from 'react';

type Props = {
  readonly selected?: boolean;
  readonly icon?: ReactNode;
  readonly expanded?: boolean;
} & (
  | {
      readonly href: string;
      readonly onClick?: NonNullable<MenuItemProps<'a'>['onClick']>;
    }
  | {
      readonly href?: never;
      readonly onClick?: NonNullable<MenuItemProps<'li'>['onClick']>;
    }
);

export const SideNavbarItem: FC<PropsWithChildren<Props>> = props => {
  const { children, icon, expanded, ...rest } = props;
  const ExpandIcon = expanded === true ? <ExpandLessIcon /> : <ExpandMoreIcon />;

  return (
    <MenuItem disableTouchRipple={expanded != null} component={rest.href ? Link : 'li'} {...rest}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={children} />
      {expanded != null ? ExpandIcon : undefined}
    </MenuItem>
  );
};
